const NEW_TAB_URLS = ['customstore', 'https://mansangsa.com/'];

export { NEW_TAB_URLS };
